<template>
    <input :id="el" type="text" :disabled="disabled" />
</template>

<style scoped>
    input {
        color: black;
        float: left;
        width: 100%;
        height: 100%;
    }
</style>

<script>
//require('pikaday/css/pikaday.css');

import "pikaday/css/pikaday.css"
// import Pikaday from 'pikaday';
    export default{
        props:['el','type','maxdate','mindate','defalutdate','disabled'],
        data(){
            return {
                pikaday:null
            }
        },
        mounted:function(){
            var Pikaday = require('pikaday')
            let datetime_i18n_zh = {
                previousMonth: '上个月',
                nextMonth: '下个月',
                months: [
                    '一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月',
                    '十一月', '十二月'
                ],
                weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
                weekdaysShort: ['日', '一', '二', '三', '四', '五', '六']
            };
            let date =new Date();
            // var defaultDate;
            // if(this.defalutdate){
            //     defaultDate = this.defalutdate
            // }else{
            //     defaultDate = new Date()
            // }
            this.pikaday = new Pikaday ({
                field: document.getElementById(this.el),
                i18n: datetime_i18n_zh,
                defaultDate: this.defalutdate,
                yearRange: 30,
                showMonthAfterYear: true,
                minDate: this.mindate,
                maxDate:date,
                onSelect: d => {
                    var month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                    if (month.length < 2) 
                        month = '0' + month;
                    if (day.length < 2) 
                        day = '0' + day;
                    $("#"+this.el).val([year, month, day].join('-'));
                    this.$emit('changedate',e,this.type);
                }
            });
        },
        watch:{
            mindate: {
            handler: function (val, oldVal) {
                this.pikaday.config({ minDate: val });
            },
            deep: true
            }
        }
    } 
</script>